"use client";

import { SiteTemplatePageSectionTypeShippingDefaultListItemSettingModel } from "@/Apis/ClinicApi";
import { ShippingSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeThirteenShippingSectionGenerated, {
  HomeThirteenShippingSectionGeneratedProps,
} from "../Sections/_generated/HomeThirteenShippingSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

const GeneratedShippingSection: FC<ShippingSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeThirteenShippingSectionGeneratedProps>(
      "HomeThirteenShippingSection",
    );
  const configuredItems = props.lists.Default ?? [];

  const shippingItems =
    configuredItems.length > 0
      ? configuredItems.map(
          (
            item: SiteTemplatePageSectionTypeShippingDefaultListItemSettingModel,
            index,
          ) => {
            const baseItem =
              defaults.shippingSection366s[
                index % defaults.shippingSection366s.length
              ] ?? defaults.shippingSection366s[0];

            return {
              ...baseItem,
              key: item.Id,
              h40Text: item.Title ?? baseItem?.h40Text ?? "",
              p0Text: item.Description ?? baseItem?.p0Text ?? "",
              i0ClassName: item.Icon ?? baseItem?.i0ClassName ?? "",
            };
          },
        )
      : defaults.shippingSection366s;

  return (
    <HomeThirteenShippingSectionGenerated
      {...defaults}
      shippingSection366s={shippingItems}
    />
  );
};

export default GeneratedShippingSection;
